import '../../TEvents/TEventDialog.scss';

import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";

import {clearLocationsCache, getLocations} from "../../Util";
import {Location} from "../../types";
import IconToggleButton from "../../../1. Core/Controls/IconToggleButton/IconToggleButton";
import DataTable from "../../../1. Core/Controls/DataTable/DataTable";

import LocDialog from "./LocDialog";


export default class LocationListDialog extends Dialog {
	private _dataTable: DataTable;


	_initFields(settings: object)
	{

		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Locations');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = false;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 850;
		this._ContentAutoFit = true;
	}

	_render()
	{
		super._render();
		this.addClass('nopad')

		this.setContent(this._dataTable = new DataTable({
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'Name',
				Width: '25%'
			}, {
				Content: NP.RM.getString('Country'),
				PropertyContent: 'Country',
				Width: '25%'
			}, {
				Content: NP.RM.getString('State'),
				PropertyContent: 'State',
				Width: '25%'
			}, {
				Content: NP.RM.getString('City'),
				PropertyContent: 'City',
				Width: '25%'
			}],
			ShowPaginator: false,

			EvItemClick: (s: object, e: { Item: Location }) =>
			{
				new LocDialog({
					Location: e.Item,
					EvOkButtonClick: () => this.refresh()
				}).show();
			}
		}));


		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.add,
			Tooltip: NP.RM.getString('Create'),
			EvClick: () =>
			{
				new LocDialog({
					EvOkButtonClick: () => this.refresh()
				}).show();
			}
		}));

		this.refresh();
	}


	refresh()
	{
		clearLocationsCache();
		getLocations().then((res: Location[]) =>
		{
			this._dataTable.setRows(res);
		});
	}

}